import { render, staticRenderFns } from "./ServiceOrderWorkflowComponent.vue?vue&type=template&id=513e3fc4&"
import script from "./ServiceOrderWorkflowComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderWorkflowComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports